export const gamesPage = {
    'games.page.title': 'Игры',
}
